<div class="ks-container">
  <a class="ks-back ks-rise-1" routerLink="/dashboard/catalogues/prefills">
    <i class="bi bi-arrow-left" aria-hidden="true"></i>
    Volver a prerellenados
  </a>

  <!-- Orden obligatorio: carga -> error de carga -> ficha -> no encontrado. El
       estado "no encontrado" solo puede aparecer cuando ya se sabe que no
       hay datos. -->
  @if (!loaded()) {
    <section class="ks-panel ks-rise-2">
      <div class="ks-skeleton-stack">
        <app-skeleton shape="block" height="140px" label="Cargando el prerellenado" />
        <app-skeleton width="40%" height="18px" />
        <app-skeleton width="65%" />
      </div>
    </section>

    <section class="ks-panel ks-rise-3">
      <div class="ks-skeleton-stack">
        <app-skeleton width="30%" height="18px" label="Cargando los valores" />
        <app-skeleton height="44px" [count]="4" />
      </div>
    </section>
  } @else if (error()) {
    <section class="ks-panel ks-rise-2">
      <app-empty-state
        icon="wifi-off"
        title="No se pudo cargar el prerellenado"
        [message]="error()!">
        <button type="button" class="ks-btn ks-btn--glass ks-btn--sm" (click)="reload()">
          <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
          Reintentar
        </button>
      </app-empty-state>
    </section>
  } @else if (prefill(); as prefill) {
    <section class="ks-panel ks-rise-2 ks-head" aria-labelledby="ks-prefill-name">
      <span class="ks-head__thumb" aria-hidden="true">
        @if (prefill.image) {
          <img [src]="prefill.image.urlFile" alt="" />
        } @else {
          <i class="bi bi-bookmark"></i>
        }
      </span>

      <div class="ks-head__body">
        <h1 class="ks-page-title" id="ks-prefill-name">{{ prefill.name }}</h1>

        <div class="ks-head__meta">
          <span class="ks-chip ks-chip--teal">
            <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
            {{ templateName() }}
          </span>

          @if (prefill.status) {
            <span class="ks-badge ks-badge--success">Activo</span>
          } @else {
            <span class="ks-badge ks-badge--muted">Inactivo</span>
          }
        </div>

        <dl class="ks-head__dates">
          <div>
            <dt>Creado</dt>
            <dd>{{ prefill.createdAt | dateToMoment }}</dd>
          </div>
          <div>
            <dt>Actualizado</dt>
            <dd>{{ prefill.updatedAt | dateToMoment }}</dd>
          </div>
        </dl>
      </div>

      <div class="ks-head__actions">
        <button type="button" class="ks-btn ks-btn--glass ks-btn--sm" (click)="edit()">
          <i class="bi bi-pencil" aria-hidden="true"></i>
          Editar
        </button>

        @if (prefill.status) {
          <button type="button" class="ks-btn ks-btn--red ks-btn--sm" (click)="deactivate()">
            <i class="bi bi-slash-circle" aria-hidden="true"></i>
            Desactivar
          </button>
        } @else {
          <button type="button" class="ks-btn ks-btn--green ks-btn--sm" (click)="activate()">
            <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
            Activar
          </button>
        }
      </div>
    </section>

    <section class="ks-panel ks-rise-3" aria-labelledby="ks-prefill-values-heading">
      <div class="ks-card__header">
        <div>
          <h2 class="ks-card__title" id="ks-prefill-values-heading">Valores</h2>
          <p class="ks-panel__hint">
            Un valor por campo de la plantilla. Los campos protegidos se muestran ocultos: hay que
            revelarlos para leerlos.
          </p>
        </div>

        <button
          type="button"
          class="ks-btn ks-btn--primary ks-btn--sm"
          [disabled]="availableFields().length === 0"
          (click)="createValue()">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          Nuevo valor
        </button>
      </div>

      @if (availableFields().length === 0 && values().length > 0) {
        <p class="ks-note" role="status">
          <i class="bi bi-check2-circle" aria-hidden="true"></i>
          Todos los campos activos de la plantilla ya tienen valor.
        </p>
      }

      @if (values().length === 0) {
        <app-empty-state
          icon="input-cursor-text"
          title="Sin valores"
          message="Este prerellenado todavía no propone ningún dato. Agrega el primero desde los campos de su plantilla.">
          <button
            type="button"
            class="ks-btn ks-btn--glass ks-btn--sm"
            [disabled]="availableFields().length === 0"
            (click)="createValue()">
            <i class="bi bi-plus-lg" aria-hidden="true"></i>
            Nuevo valor
          </button>
        </app-empty-state>
      } @else {
        <div class="ks-table-wrap">
          <table class="ks-table ks-table--compact">
            <caption class="ks-visually-hidden">
              Valores del prerellenado, en el orden de los campos de la plantilla.
            </caption>

            <thead>
              <tr>
                <th scope="col">Campo</th>
                <th scope="col">Tipo</th>
                <th scope="col">Valor</th>
                <th scope="col">Actualizado</th>
                <th scope="col"><span class="ks-visually-hidden">Acciones</span></th>
              </tr>
            </thead>

            <tbody>
              @for (value of values(); track value.prefillValueId) {
                <tr>
                  <td>
                    {{ value.templateField?.label ?? 'Campo no disponible' }}
                    @if (value.templateField?.required) {
                      <span class="ks-req" aria-label="Campo obligatorio">*</span>
                    }
                  </td>

                  <td>
                    @if (value.templateField; as field) {
                      <span class="ks-chip ks-chip--purple ks-mono">{{ field.fieldType }}</span>
                    } @else {
                      <span class="ks-badge ks-badge--muted">Desconocido</span>
                    }
                  </td>

                  <td>
                    <div class="ks-value">
                      <span class="ks-value__text" [class.ks-value__text--masked]="isProtected(value) && !isRevealed(value)">
                        {{ displayValue(value) }}
                      </span>

                      @if (isProtected(value)) {
                        <button
                          type="button"
                          class="ks-icon-btn ks-value__toggle"
                          [attr.aria-label]="(isRevealed(value) ? 'Ocultar el valor de ' : 'Mostrar el valor de ') + (value.templateField?.label ?? 'el campo')"
                          [attr.aria-pressed]="isRevealed(value)"
                          (click)="toggleReveal(value)">
                          <i
                            class="bi"
                            [class.bi-eye]="!isRevealed(value)"
                            [class.bi-eye-slash]="isRevealed(value)"
                            aria-hidden="true"></i>
                        </button>
                      }
                    </div>
                  </td>

                  <td class="ks-muted">{{ value.updatedAt | dateToMoment }}</td>

                  <td>
                    <div class="ks-table__actions">
                      <button
                        type="button"
                        class="ks-icon-btn"
                        [attr.aria-label]="'Editar el valor de ' + (value.templateField?.label ?? 'el campo')"
                        (click)="editValue(value)">
                        <i class="bi bi-pencil" aria-hidden="true"></i>
                      </button>

                      <button
                        type="button"
                        class="ks-icon-btn ks-icon-btn--danger"
                        [attr.aria-label]="'Eliminar permanentemente el valor de ' + (value.templateField?.label ?? 'el campo')"
                        (click)="deleteValue(value)">
                        <i class="bi bi-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  } @else {
    <section class="ks-panel ks-rise-2">
      <app-empty-state
        icon="exclamation-triangle"
        title="Prerellenado no encontrado"
        message="El prerellenado no existe o ya no está disponible.">
        <a class="ks-btn ks-btn--glass ks-btn--sm" routerLink="/dashboard/catalogues/prefills">
          Volver a prerellenados
        </a>
      </app-empty-state>
    </section>
  }
</div>
